/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

import moment from 'moment-timezone';
import { RangePreset } from 'cio/utils/date-picker';

interface AddActionsPanelMetricsArgs {
  dateRangePresets: RangePreset[];
  timeRange: { start: moment.Moment; end: moment.Moment };
  onRangeSelect: (range: { start: moment.Moment; end: moment.Moment }, presetValue: string) => unknown;
}

export default class AddActionsPanelMetrics extends Component<AddActionsPanelMetricsArgs> {
  get maxDate() {
    let now = moment.tz('Etc/GMT+4');

    return moment(`${now.format('YYYY-MM-DD')} 00:00:00`);
  }

  @action
  selectRange(value: any) {
    if (!value.date?.start || !value.date?.end) {
      return;
    }

    let { start, end } = value.date;

    let selectedPreset = this.args.dateRangePresets.find((preset) => {
      let presetRange = preset.getRange();

      if (!presetRange.start || !presetRange.end) {
        return false;
      }

      return presetRange.start.isSame(start) && presetRange.end.isSame(end);
    });

    if (selectedPreset) {
      return this.args.onRangeSelect(selectedPreset.getRange(), selectedPreset.value);
    } else {
      return this.args.onRangeSelect(
        {
          start: value.date.start,
          end: value.date.end,
        },
        'custom',
      );
    }
  }
}
